import {
  ConfirmToolMutation,
  ConfirmToolMutationVariables,
  ConversationsV2ToolConfirmationResponseDecision,
  useConfirmToolMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

type ConfirmToolResult = Extract<
  NonNullable<ConfirmToolMutation['confirmTool']>,
  { __typename: 'ConversationsV2ConfirmToolResponse' }
>;

export const useConfirmTool = withStandardMutationHook<
  ConfirmToolMutation,
  ConfirmToolResult,
  ConfirmToolMutationVariables,
  'confirmTool',
  [string, ConversationsV2ToolConfirmationResponseDecision]
>(useConfirmToolMutation, 'confirmTool', (name, decision) => ({
  name,
  decision,
}));
